<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Account Balance</div>
      <div class="p-3">
        <button class="btn btn-primary" (click)="refreshBalance()" [disabled]="loading">
          <i class="bi bi-arrow-clockwise" [class]="loading ? 'spinner-border spinner-border-sm' : ''"></i>
          {{ loading ? 'Refreshing...' : 'Refresh Balance' }}
        </button>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <!-- Loading indicator -->
        @if (loading) {
          <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }

        <!-- Error message -->
        @if (error && !loading) {
          <div class="alert alert-danger mt-3">
            {{ error }}
          </div>
        }

        <!-- Balance information -->
        @if (!loading && !error && balance) {
          <div class="mt-4">
            <div class="card mb-4">
              <div class="card-header bg-primary text-white">
                <h4 class="mb-0">Current Balance</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label fw-bold">Account Name</label>
                      <p class="mb-0">{{ balance.name }}</p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label fw-bold">Available Balance</label>
                      <div class="d-flex align-items-center">
                        <h2 class="text-success mb-0">
                          {{ balance.availableBalance.amount | number }} {{ balance.availableBalance.currency }}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body text-center">
                <h5 class="card-title">Balance Information</h5>
                <p class="card-text">Your current Airalo account balance is displayed above.</p>
                <p class="text-muted">This balance reflects your available funds for purchasing eSIM packages.</p>
              </div>
            </div>
          </div>
        }

        <!-- No balance message -->
        @if (!loading && !error && !balance) {
          <div class="alert alert-info mt-3">
            No balance information available.
          </div>
        }
      </div>
    </div>
  </div>
</div>